<template>
  <v-container class="ma-0 pa-0" style="height: 100%">
    <div class="ma-0 pa-0" align-items="center" align="start" flat>
      <v-row class="ma-2 pb-6">
        <v-alert type="info" class="ma-0 pa-2" :class="isOnMobile ? '' : 'mr-8'" dense dismissible>
          <span class="subtitle-2">Моля, попълнете данните за фактура само ако извършвате плащанията директно към Тремол ООД. В случай, че плащанията минават през дистрибутор е необходимо да уточните съответните данни за фактура с него.</span>
        </v-alert>
      </v-row>
      <v-form ref="refInvoiceData" lazy-validation class="px-3 pb-3 pt-0 mt-0" style="max-width: 600">
        <v-row class="ma-2 pb-2">
          <v-text-field dense :rules="validInvBuyer" class="ma-0 pa-0" v-model="invoice.invCompanyName" label="Име на фирма"></v-text-field>
        </v-row>
        <v-row class="ma-2 pb-2">
          <v-text-field dense :rules="global_rules.required" class="ma-0 pa-0" v-model="invoice.invMol" label="Получател"></v-text-field>
        </v-row>
        <v-row class="ma-2 pb-2">
          <v-text-field dense :rules="validInvAddress" class="ma-0 pa-0" v-model="invoice.invRegAddress" label="Адрес"></v-text-field>
        </v-row>
        <v-row class="ma-2 pb-2" justify="center" align="center">
          <v-text-field v-if="uicFormat == optionUIC[0]" :rules="[...global_rules.required, ...global_rules.number, ...global_rules.validEIK]" dense class="ma-0 pa-0" v-model="invoice.invEik" @change="vatRegChange" :label="uicFormat + ' (само цифри)'"></v-text-field>
          <!-- <v-col xs="12" sm="12" md="3" lg="3" class="ma-0 pa-0">
          <v-select class="ma-0 pa-0 mr-2" @change="clearUIC" dense item-text="name" :items="optionUIC" v-model="uicFormat" label="Тип на ЕИК"></v-select>
        </v-col>
        <v-text-field v-if="uicFormat == optionUIC[0]" :rules="validEIK" dense class="ma-0 pa-0" v-model="invoice.invEik" :label="uicFormat" required></v-text-field>
        <v-text-field v-else-if="uicFormat == optionUIC[1]" :rules="validEGN" class="ma-0 pa-0" v-model="invoice.invEik" :label="uicFormat" required></v-text-field>
        <v-text-field v-else-if="uicFormat == optionUIC[2]" :rules="validLNCH" dense class="ma-0 pa-0" v-model="invoice.invEik" :label="uicFormat" required></v-text-field>
          <v-text-field v-else dense class="ma-0 pa-0" :rules="required" v-model="invoice.invEik" :label="uicFormat" required></v-text-field>-->
          <!-- <v-text-field dense class="ma-0 pa-0" :rules="uicFormat==optionUIC[0].value? validEIK: uicFormat==optionUIC[1].value? validEGN: uicFormat==optionUIC[2].value? validLNCH: undefined" v-model="invEik" :label="chosenUIC[0]" required></v-text-field> -->
        </v-row>
        <v-row class="ma-2 pb-2">
          <v-checkbox class="ma-0 pa-0" label="Регистрация по ЗДДС" v-model="isVATregistered" @click="vatRegChange"></v-checkbox>
          <!-- <v-text-field dense :rules="validVATNum" class="ma-0 pa-0" v-model="invoice.invZDDSnom" label="ЗДДС номер"></v-text-field> -->
        </v-row>
        <v-row class="ma-0 pa-0">
          <!-- <v-switch hide-details dense inset label="Желая да получавам фактура при плащания към Тремол ООД." v-model="invoice.requireInvoice"></v-switch> -->
          <!-- <v-spacer></v-spacer> -->
          <t-button :class="'ma-1'" :btnDisabled="isSaveDisabled" style="min-width: 120px" :btnIcon="'mdi-checkbox-marked-circle-outline'" :btnText="`Запази`" @click.native="save(true)" />
          <t-button :class="'ma-1'" :btnDisabled="isSaveDisabled" style="min-width: 120px" :btnIcon="'mdi-minus-circle'" :btnText="`Премахни`" @click.native="save(false)" />
        </v-row>
      </v-form>
    </div>
  </v-container>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";

export default {
  props: {
    invoiceData: {},
  },
  data() {
    return {
      isVATregistered: false,
      isSaveDisabled: false,
      egnChecksumDigits: ["2", "4", "8", "5", "10", "9", "7", "3", "6"],
      lnchChecksumDigits: ["21", "19", "17", "13", "11", "9", "7", "3", "1"],
      invoice: this.invoiceData || {
        invCompanyName: "",
        invMol: "",
        invRegAddress: "",
        invEik: "",
        invZDDSnom: "",
        requireInvoice: true,
      },
      user: null,
      uicFormat: "БУЛСТАТ",
      optionUIC: ["БУЛСТАТ", "ЕГН", "ЛНЧ", "НАП номер"],
      validInvBuyer: [(v) => !!v || "Задължително поле", (v) => v.length <= 60 || "Името на фирмата не може да превиша 60 символа!", (v) => this.checkCyrrillic(v)],
      validInvAddress: [(v) => !!v || "Задължително поле", (v) => v.length <= 80 || "Адресът не може да превиша 80 символа!", (v) => this.checkCyrrillic(v)],
      validVATNum: [(v) => !!v || "Задължително поле", (v) => (v.length >= 9 && v.length <= 13) || "ЗДДС номерът трябва да бъде от 9 до 13 символа!"],
      // validEIK: [(v) => !!v || "Задължително поле", (v) => !isNaN(v) || "Моля, въведете само цифри!", (v) => (v.length >= 9 && v.length <= 13) || "ЕИК/БУЛСТАТ трябва да бъде минимум 9 символа и не повече от 13", (v) => this.isValidEIK(v) || "Невалиден ЕИК/БУЛСТАТ"],
      validEGN: [(v) => !!v || "Задължително поле", (v) => v.length == 10 || "ЕГН трябва да бъде 10 символа", (v) => this.checkEGN(v) || "Невалиден ЕГН"],
      validLNCH: [(v) => !!v || "Задължително поле", (v) => v.length == 10 || "ЛНЧ трябва да бъде 10 символа", (v) => this.checkLNCH(v) || "Невалиден ЛНЧ"],
    };
  },
  mounted() {
    if (!this.invoice.invEik) {
      var user = DataManager.getData(DataManager.DataType.user, true);
      this.invoice.invMol = user.firstName + " " + user.middleName + " " + user.lastName;
      this.invoice.invRegAddress = "";
      this.invoice.invEik = user.eik;
      // this.invoice.invZDDSnom = "BG" + user.eik;
    }
  },
  methods: {
    setTitleAndData(meta, error) {
      if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
        this.user = DataManager.getData(DataManager.DataType.user);
        if (this.user.invCompanyName) {
          this.invoice = {
            invCompanyName: this.user.invCompanyName ?? "",
            invMol: this.user.invMol ?? "",
            invRegAddress: this.user.invRegAddress ?? "",
            invEik: this.user.invEik ?? "",
            invZDDSnom: this.user.invZDDSnom ?? "",
            requireInvoice: true,
          };
        }
        if (this.invoice.invZDDSnom && this.invoice.invZDDSnom.startsWith("BG")) {
          this.isVATregistered = true;
        }
        this.vatRegChange();
      } else {
        this.dialogLoader.showError(error.Message);
      }
    },
    vatRegChange() {
      if (this.isVATregistered) {
        this.invoice.invZDDSnom = "BG" + this.invoice.invEik;
      } else {
        this.invoice.invZDDSnom = this.invoice.invEik;
      }
    },
    save(set) {
      if (!set || this.$refs.refInvoiceData.validate()) {
        this.isSaveDisabled = true;
        this.invoice.requireInvoice = set;
        if (set) {
          this.invoice.invCompanyName = this.invoice.invCompanyName.toTitleCase().replace("оод", "ООД").replace("Оод", "ООД");
          this.invoice.invMol = this.invoice.invMol.toTitleCase();
          this.invoice.invRegAddress = this.invoice.invRegAddress.toTitleCase();
        } else {
          this.invoice.invCompanyName = "";
          this.invoice.invMol = "";
          this.invoice.invRegAddress = "";
          this.invoice.invEik = "";
          this.invoice.invZDDSnom = "";
        }
        DataManager.updateUserInvoiceData(this.invoice, (error) => {
          if (error.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
            if (set) {
              this.dialogLoader.showInfo("Успешна промяна на данни за фактура.");
            } else {
              this.dialogLoader.showInfo("Успешно премахване на данни за фактура.");
            }
            // this.$refs.refInvoiceData.reset();

            this.$nextTick(() => {
              DataManager.loadData(DataManager.DataType.user, null, true);
            });
          } else {
            this.dialogLoader.showError(error.Message);
          }
          setTimeout(() => {
            this.isSaveDisabled = false;
          }, 5000);
        });
      }
    },
    checkLNCH(n) {
      let sum = 0;
      let checksum = 0;
      for (let i = 0; i < n.length - 1; i++) {
        sum = sum + this.lnchChecksumDigits[i] * n.charAt(i);
      }
      if (checksum % 10 == n.slice(-1)) {
        return true;
      } else {
        return false;
      }
    },
    checkEGN(n) {
      let sum = 0;
      let checksum = 0;
      for (let i = 0; i < n.length - 1; i++) {
        sum = sum + this.egnChecksumDigits[i] * n.charAt(i);
      }
      if (sum % 11 == 0 || sum % 11 == 10) {
        checksum = 0;
      } else {
        checksum = sum % 11;
      }
      if (checksum == n.slice(-1)) {
        return true;
      } else {
        return false;
      }
    },
    /** @param {String} n */
    checkCyrrillic(n) {
      const a = '1234567890АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЬЮЯ",.№-- ';
      for (var i = 0; i < n.length; i++) {
        var ch = n[i];
        if (a.indexOf(ch.toString().toUpperCase()) == -1) {
          return "Невалиден символ: " + ch;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
</style>